import { createCancellationReasonMachine } from '@eneco/flows/machines';

export const reasonMachine = createCancellationReasonMachine('toonservice');
